import { useQuery } from '@tanstack/react-query';

import axiosApiInstance from 'commons/utils/axios/axiosApiInstance';
import { useStoreContext } from 'commons/utils/hooks/useStoreContext';
import { StoreConfigsResponseDto } from 'commons/utils/types/store-configs-response-dto';

export const fetchConfigs = async (): Promise<StoreConfigsResponseDto> => {
  const response = await axiosApiInstance.get(`stores/configs`);
  return response.data;
};

export const useStoreConfigs = () => {
  const store = useStoreContext();

  return useQuery(['store-configs'], fetchConfigs, {
    staleTime: 1000 * 60 * 10,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    enabled: !!store?.externalStoreId
  });
};
